import { StyleSheet, TextStyle } from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

export const styles = StyleSheet.create({
  hero: {
    flexGrow: 1,
    flexShrink: 0,
    justifyContent: 'space-evenly',
  },
  header: {
    ...(Fonts.style.h2 as TextStyle),
    textAlign: 'center',
    color: Colors.coal,
  },
  body: {
    ...Fonts.style.normal,
    color: Colors.textGray,
    textAlign: 'center',
    lineHeight: 20,
  },
  h1: {
    fontSize: Fonts.size.h1,
    lineHeight: Fonts.size.h1 * 1.5,
  },
  h2: {
    fontSize: Fonts.size.h2,
    lineHeight: Fonts.size.h2 * 1.25,
  },
  h3: {
    fontSize: Fonts.size.h3,
  },
  h4: {
    fontSize: Fonts.size.h4,
  },
  h5: {
    fontSize: Fonts.size.h5,
  },
  h6: {
    fontSize: Fonts.size.h6,
  },
})
